import getMembershipPanelCopy from '@/catalog/utils/get-membership-panel-copy';
import { withPageContainerStyles } from '@/common/components/page-layout';
import Spacer from '@/common/components/spacer';
import { getDynamicCurrency } from '@/util-conversion/currency/currency-to-string';
import { RefObject } from 'react';

interface MembershipPanelProps {
  gasCents: string;
  membershipCost: string;
  cdnUrl: string;
  scrollRef: RefObject<HTMLDivElement | null>;
}

export default function MembershipPanel({
  gasCents,
  membershipCost,
  cdnUrl,
  scrollRef,
}: MembershipPanelProps) {
  const sections = getMembershipPanelCopy(gasCents);

  const mobileBg = `${cdnUrl}/web/images/membership-bg.webp`;
  return (
    <div ref={scrollRef} className="w-full">
      {/* Mobile/Tab */}
      <div className="relative w-full bg-[linear-gradient(180deg,#F4F5F6_50%,#FFF_50%)] lg:hidden">
        <img
          src={mobileBg}
          alt="Membership card background"
          className="absolute inset-0 z-0 h-full w-full rounded-[40px] border-[1px] border-solid border-[#D3DDFF] object-cover shadow-membershipShadow"
          fetchPriority="auto"
          loading="lazy"
        />
        <div className="relative z-1 flex flex-col items-center px-[24px] py-[30px]">
          <img
            src={`${cdnUrl}/web/images/membership-logo-chrome.webp`}
            alt="Flexcar logo chrome"
            className="h-[68px] w-[68px]"
            fetchPriority="auto"
            loading="lazy"
          />
          <Spacer variant="height16" />
          <h1 className="text-center text-flexcar-neutral100">Flexcar Membership</h1>
          <Spacer variant="height16" />
          <p className="body2-string w-fit rounded-[100px] border-[1.5px] border-solid border-flexcar-neutral80 px-[8px] py-[4px] text-flexcar-neutral100">
            {getDynamicCurrency(Number(membershipCost))}/yr
          </p>
          <Spacer variant="height40" />
          <div className="flex flex-col gap-[24px]">
            {sections.map((section, index) => (
              <div
                className="flex flex-row gap-[8px]"
                key={`mob-${index}-${section.title}`}
              >
                {section.icon}
                <div>
                  <p className="body-strong text-flexcar-neutral100">{section.title}</p>
                  <Spacer variant="height8" />
                  {section.description}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Desktop */}
      <div className="relative hidden w-full bg-[radial-gradient(183.48%_128.21%_at_16.5%_19.87%,#0B0C0E_0%,#273256_58.05%,#7B6691_80.48%,#C1A4C5_100%)] lg:block">
        <div className={withPageContainerStyles('mx-auto my-0 max-w-[1440px] p-[80px]')}>
          <p className="body2-string w-fit rounded-[100px] border-[1.5px] border-solid border-flexcar-neutral80 px-[8px] py-[4px] text-flexcar-neutral100">
            {getDynamicCurrency(Number(membershipCost))}/yr
          </p>
          <Spacer variant="height16" />
          <h1 className="text-flexcar-neutral100">Flexcar Membership</h1>
          <Spacer variant="height56" />
          <div className="flex w-[60%] max-w-[800px] flex-row gap-[40px]">
            {sections.map((section, index) => (
              <div
                className="flex flex-row gap-[8px]"
                key={`desk-${index}-${section.title}`}
              >
                {section.icon}
                <div>
                  <p className="body-strong text-flexcar-neutral100">{section.title}</p>
                  <Spacer variant="height8" />
                  {section.description}
                </div>
              </div>
            ))}
          </div>
        </div>

        <img
          src={`${cdnUrl}/web/images/membership-card-bg.webp`}
          alt="Membership card"
          className="absolute bottom-[-86px] right-0 w-[420px]"
          fetchPriority="auto"
          loading="lazy"
        />
      </div>
    </div>
  );
}
